export default "__VITE_ASSET__CwPAYkXz__"